/**
 * Shared constants for dialog components
 */

export const BRUSH_SIZES = [
	{ size: 3, label: 'Thin' },
	{ size: 5, label: 'Medium' },
	{ size: 7, label: 'Thick' },
	{ size: 10, label: 'Extra Thick' },
]

/**
 * Returns 9 color presets for a 3x3 grid layout
 * Includes both black AND white always (for player fills)
 */
export function getColorPresets(_theme: 'light' | 'dark') {
	return [
		{ name: 'Black', value: '#000000' },
		{ name: 'White', value: '#FFFFFF' },
		{ name: 'Red', value: '#EF4444' },
		{ name: 'Blue', value: '#3B82F6' },
		{ name: 'Green', value: '#10B981' },
		{ name: 'Orange', value: '#F97316' },
		{ name: 'Purple', value: '#8B5CF6' },
		{ name: 'Yellow', value: '#FBBF24' },
		{ name: 'Pink', value: '#EC4899' },
	]
}
